import { graphql } from 'src/graphql';

import { MessagesFields } from 'src/fragments/messagesFields.fragment';

export const FetchMessages = graphql(
  `
    query FetchMessages($search: MessageSearchInput!) {
      messages(search: $search) {
        ...MessagesFields
        UserFrom {
          meta {
            identity {
              firstname
            }
          }
        }
      }
    }
  `,
  [MessagesFields],
);
